export default function hexToRgb(hex: string, in15BitMode = false) {
    const colorArray = hex
        .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
        .substring(1)
        .match(/.{2}/g)
        ?.map((x) => {
            const val = parseInt(x, 16);
            return in15BitMode ? Math.round((val / 255) * 32768) : val;
        });

    if (colorArray?.length !== 3) {
        throw new Error("Invalid hex string");
    }

    const [red, green, blue] = colorArray;

    return { red, green, blue };
}
